import i18n from 'i18next';
import {
  DomainMode,
  shouldDeferValidationErrorWhileTyping,
  ValidationPhase,
  validateDomainOrUrl
} from '../domain-url/DomainUrlValidation';
import { translateDomainValidationErrorKey } from '../domain-url/translateDomainValidationErrorKey';

interface UrlValidatorOptions {
  mode?: DomainMode;
  getValidationPhase?: () => ValidationPhase;
}

export default function UrlValidator(
  message: string,
  allowEmpty: boolean = false,
  options: UrlValidatorOptions = {}
) {
  return ({}) => ({
    validator: (_, value) => {
      if (allowEmpty && !value) {
        return Promise.resolve();
      }

      if (!value) {
        // If not allowed to be empty, and is empty
        return Promise.reject(new Error(message || 'URL is required.'));
      }
      const phase = options.getValidationPhase?.() || 'typing';
      const mode = options.mode || 'user_has_existing_website_domain';
      const validation = validateDomainOrUrl({
        value,
        mode,
        phase
      });

      if (validation.isValid) {
        return Promise.resolve();
      }

      if (shouldDeferValidationErrorWhileTyping(validation.errorKey, phase)) {
        return Promise.resolve();
      }

      const localizedMessage = validation.errorKey
        ? translateDomainValidationErrorKey(i18n.t.bind(i18n), validation.errorKey)
        : message;

      return Promise.reject(new Error(localizedMessage));
    }
  });
}
